import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Checkbox, IconSuccessful16 } from '@cian/ui-kit';
import cn from 'clsx';
import { PureComponent } from 'react';
import styles from './LabelCheckbox.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LabelCheckbox = /*#__PURE__*/function (_PureComponent) {
  _inherits(LabelCheckbox, _PureComponent);

  var _super = _createSuper(LabelCheckbox);

  function LabelCheckbox() {
    var _this;

    _classCallCheck(this, LabelCheckbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          changeData = _this$props.changeData;
      onClick(changeData, event);
    });

    return _this;
  }

  _createClass(LabelCheckbox, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          checked = _this$props2.checked,
          label = _this$props2.label,
          theme = _this$props2.theme,
          deviceType = _this$props2.deviceType;

      switch (theme) {
        case 'nested-checkbox':
        case 'titled-checkbox':
          return deviceType === 'desktop' ? /*#__PURE__*/_jsxs("label", {
            className: this.getContainerClassNames(),
            children: [/*#__PURE__*/_jsx("div", {
              className: styles['checkbox-wrapper'],
              children: /*#__PURE__*/_jsx(Checkbox, {
                checked: checked,
                onChange: this.handleClick
              })
            }), /*#__PURE__*/_jsx("div", {
              className: styles['label'],
              children: label
            })]
          }) : /*#__PURE__*/_jsxs("label", {
            className: this.getContainerClassNames(),
            children: [/*#__PURE__*/_jsx("div", {
              className: styles['label'],
              children: label
            }), /*#__PURE__*/_jsx("div", {
              className: styles['checkbox-wrapper'],
              children: /*#__PURE__*/_jsx(Checkbox, {
                checked: checked,
                onChange: this.handleClick
              })
            })]
          });

        case 'nested-checkmark':
        case 'titled-checkmark':
          return /*#__PURE__*/_jsxs("label", {
            className: this.getContainerClassNames(),
            children: [/*#__PURE__*/_jsx("input", {
              "aria-hidden": true,
              checked: checked,
              className: styles['hidden-input'],
              type: "checkbox",
              onChange: this.handleClick
            }), /*#__PURE__*/_jsx("div", {
              className: styles['label'],
              children: label
            }), /*#__PURE__*/_jsx("div", {
              className: styles['checkmark-wrapper'],
              children: /*#__PURE__*/_jsx(IconSuccessful16, {
                color: "primary_100"
              })
            })]
          });
      }
    }
  }, {
    key: "getThemeStyles",
    value: function getThemeStyles() {
      var theme = this.props.theme;

      switch (theme) {
        case 'nested-checkbox':
        case 'nested-checkmark':
        case 'titled-checkbox':
        case 'titled-checkmark':
          return styles["theme-".concat(theme)];
      }
    }
  }, {
    key: "getDeviceTypeStyles",
    value: function getDeviceTypeStyles() {
      var deviceType = this.props.deviceType;

      switch (deviceType) {
        case 'desktop':
        case 'phone':
        case 'tablet':
          return styles["device-type-".concat(deviceType)];
      }
    }
  }, {
    key: "getContainerClassNames",
    value: function getContainerClassNames() {
      var checked = this.props.checked;
      return cn(styles['container'], this.getThemeStyles(), this.getDeviceTypeStyles(), checked && styles['checked']);
    }
  }]);

  return LabelCheckbox;
}(PureComponent);